import { render, staticRenderFns } from "./workspaces_ag.vue?vue&type=template&id=309f00f0"
import script from "./js/workspaces_ag.js?vue&type=script&lang=js&external"
export * from "./js/workspaces_ag.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports